import clsx from 'clsx';

interface SkeletonProps {
  children: React.ReactNode;
  className?: string;
}

export function Skeleton({ children, className }: SkeletonProps) {
  return (
    <div className={clsx('animate-pulse motion-reduce:animate-none', className)}>{children}</div>
  );
}
